import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectClientId } from '../../app.selector';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
})
export class NotfoundComponent  {
  msg: any;
  $clientId: Observable<string>;
  constructor(
    private router:Router,
    private store: Store
  ) {
    this.msg = this.router.getCurrentNavigation()?.extras?.state?.msg;
  }

  ngOnInit() {
    this.$clientId = this.store.select(selectClientId);
  }
}
